"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const JsonQueryError_1 = tslib_1.__importDefault(require("./errors/JsonQueryError"));
const fetchRawQuery_1 = tslib_1.__importDefault(require("./fetchRawQuery"));
const JsonQuery_1 = tslib_1.__importDefault(require("./queries/JsonQuery"));
const handleResponse_1 = tslib_1.__importDefault(require("./utils/handleResponse"));
async function fetchJsonQuery(request, { ctrl, handlers = {} }) {
    const query = await (0, fetchRawQuery_1.default)(request, { ctrl });
    const { response } = query;
    const contentType = response.headers.get("Content-Type");
    if (contentType !== "application/json") {
        throw new JsonQueryError_1.default(`Return Content-Type is not 'application/json'. It is '${contentType}'`, request, ctrl, response, null);
    }
    // Parsing the json body
    let json = null;
    try {
        json = await response.json();
    }
    catch (ex) {
        throw new JsonQueryError_1.default(`Failed to parse JSON body from response`, request, ctrl, response, ex);
    }
    return (0, handleResponse_1.default)(new JsonQuery_1.default(request, response, json, ctrl), handlers);
}
exports.default = fetchJsonQuery;
